// extracted by mini-css-extract-plugin
export default {"link":"wwzc9GSdrL","last":"Kp4o62vwjp"};